import {Paper, SwipeableDrawer} from "@mui/material";
import React, {SetStateAction, useEffect, useMemo, useState} from "react";
import {useQuery} from "@tanstack/react-query";
import {PendingActionType} from "apm/types";
import {getPendingActions} from "apm/api/pending_action";
import MaterialReactTable, {MRT_ColumnDef} from "material-react-table";
import StatusUI from "apm/components/common/StatusUI";
import moment from "moment";
import {APP_FORMAT_DATE, APP_FORMAT_DATETIME} from "apm/utils/constants";
import Sort from "apm/assets/icon/Sort";
import {useNavigate} from "react-router-dom";
import useAuth from "apm/contexts/useAuth";

type PropsType = {
    open?: boolean
    setPendingActionOpen: React.Dispatch<SetStateAction<boolean>>
}
export default function PendingActionPopup({open = false, setPendingActionOpen}: PropsType) {
    const navigate = useNavigate();
    const {user} = useAuth();

    const toggleDrawer =
        (anchor: string, open: boolean) =>
            (event: React.KeyboardEvent | React.MouseEvent) => {
                if (
                    event &&
                    event.type === 'keydown' &&
                    ((event as React.KeyboardEvent).key === 'Tab' ||
                        (event as React.KeyboardEvent).key === 'Shift')
                ) {
                    return;
                }


            };
    const [isLoaded, setIsLoaded] = useState(false);
    useEffect(() => {
        setIsLoaded(true)
    }, []);
    const {
        isLoading,
        data: pendingActions,
    } = useQuery<PendingActionType[]>(
        {
            queryKey: [
                'pendingData',
                open,
            ],
            queryFn: async ({signal}) => {

                return await getPendingActions()
            },
            keepPreviousData: true,
        }
    );


    const columns = useMemo<MRT_ColumnDef<PendingActionType>[]>(
        () => [
            {
                accessorKey: 'subproject_name',
                header: 'Mine',
                filterVariant: 'text',
            },
            {
                accessorKey: 'action_type',
                header: 'Action',
                filterVariant: 'text',
            },
            {
                accessorKey: 'action_desc',
                header: 'Task/Action Description',
                size: 230,
                filterVariant: 'text',
            },
            {
                accessorKey: 'shift_name',
                header: 'Shift',
                filterVariant: 'text',
                size: 100
            },
            {
                accessorKey: 'status',
                header: 'Status',
                Cell: ({cell}) => StatusUI(cell.getValue()),
                size: 150,
                filterVariant: 'text',
            },
            {
                accessorKey: 'reporting_date',
                header: 'Reporting Date',
                Cell: ({cell, row}) => (
                    <>
                        {row.original.reporting_date &&
                            moment(row.original.reporting_date)
                                .format(APP_FORMAT_DATE)}
                    </>
                ),
                filterVariant: 'text',
            },
            {
                accessorKey: 'updated_by',
                header: 'Updated By',
                filterVariant: 'text',
            },
            {
                accessorKey: 'requested_by',
                header: 'Requested By',
                filterVariant: 'text',
            },
            {
                accessorKey: 'pending_with',
                header: 'Pending With',
                filterVariant: 'text',
            },
            {
                accessorKey: 'request_date',
                header: 'Request Date',
                filterVariant: 'text',
                size: 120,
                Cell: ({cell, row}) => (
                    <>
                        {row.original.request_date &&
                        moment
                            .unix(+row.original.request_date)
                            .format(APP_FORMAT_DATETIME)}
                    </>
                ),
            },
        ],
        []
    );    
    return (

        <SwipeableDrawer
            anchor={'top'}
            open={open}
            variant="temporary"
            sx={{
                width: '90%',
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: '94%',
                    marginLeft: '3%',
                    marginRight: '3%',
                    marginTop: '5px',
                    boxSizing: 'border-box',
                },
            }}
            onClose={toggleDrawer('top', false)}
            onOpen={toggleDrawer('top', true)}
        >
            <Paper className='p-2' sx={{minHeight: '300px', padding: ''}}>
                <div className="d-flex" >
                    <h4>Pending Actions </h4>
                    <button onClick={() => setPendingActionOpen(false)} style={{height: '30px'}}
                            className='btn btn-default btn-sm ml-auto '>
                        <i className='bi bi-x-lg '/>
                    </button>
                </div>
                {isLoaded &&  <MaterialReactTable
                    editingMode="table"
                    enableColumnActions={false}
                    enablePagination={true}
                    initialState={{density: 'compact',pagination: {
                        pageSize: 50,
                        pageIndex: 0
                      }}}
                    enableStickyHeader
                    manualFiltering={false}
                    enableTopToolbar={true}
                    enableHiding={false}
                    enableGlobalFilter={false}
                    enableDensityToggle={false}
                    columns={columns && columns}
                    data={pendingActions ? pendingActions : []}
                    state={{isLoading: isLoading}}
                    icons={{ArrowDownwardIcon: (props: any) => <Sort {...props} />}}
                    muiTableContainerProps={{
                        sx: { maxHeight: '570px'},
                    }}
                    muiTableBodyProps={{
                        sx: {
                            '& tr:nth-of-type(even)': {backgroundColor: '#F2F5F8'},
                            '& td,& td a': {color: '#1B2064'},
                        },
                    }}
                    muiTableBodyRowProps={({row}) => ({
                        onClick: () => {
                            const data: PendingActionType = row.original;
                            const {
                                project_id,
                                subproject_id,
                                slug,
                                resource_id,
                                request_id,
                                status,
                                pending_with,
                                request_user_id,
                                approver_ids
                            } = data;

                            if (status === 'rejected' && request_user_id === user.id && (approver_ids === null || approver_ids.length === 0)) {
                                window.open(`/projects/${project_id}/data-entry/working-form/sub-project/${subproject_id}/${slug}/${resource_id}`, '_blank')
                            } else {
                                window.open(`/projects/${project_id}/subproject/${subproject_id}/pending-actions/${slug}/${resource_id}/request/${request_id}`, '_blank')
                            }
                        },
                        sx: {cursor: 'pointer'},
                    })}
                />
                }
            </Paper>
        </SwipeableDrawer>

    )
}